import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';

// Returns an object with only the `data-*` attributes from the given props
// Is needed to safely pass custom data-* attributes to a DOM element in a React component

function getDataAttributes(props) {
  return Object.fromEntries(Object.entries(props).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return key.startsWith('data-');
  }));
}

export { getDataAttributes };
//# sourceMappingURL=utils.esm.js.map
